import {Component} from "@angular/core";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-box1-belastbare-periodieke-uitkeringen-en-verstrekkingen',
    templateUrl: './box1-belastbare-periodieke-uitkeringen-en-verstrekkingen.component.html',
    styleUrls: ['./box1-belastbare-periodieke-uitkeringen-en-verstrekkingen.component.scss',],
})

export class Box1BelastbarePeriodiekeUitkeringenEnVerstrekkingenComponent {

  public clientId!: string;
}
